import { DateTime } from 'luxon';

import { DateTimeCustom } from '@work4all/utils/lib/date-utils/formatDateString';

const DATE_TIME_FORMATS = {
  DATE_SHORT: DateTimeCustom.DATE_SHORT,
  TIME: 'HH:mm',
};

class DateTimeUtilsClass {
  public toDate(value: string | null) {
    if (!value) return '';
    return DateTime.fromISO(value).toLocaleString(DATE_TIME_FORMATS.DATE_SHORT);
  }

  public toTime(value: string | null) {
    if (!value) return '';
    return DateTime.fromISO(value).toFormat(DATE_TIME_FORMATS.TIME);
  }

  public updateDateFromFormatedDate(value: string, formatedDate: string) {
    const valueAsDateTime = DateTime.fromISO(value);
    const format = DateTime.parseFormatForOpts(DATE_TIME_FORMATS.DATE_SHORT);
    const dateFromFormatted = DateTime.fromFormat(formatedDate, format);

    return valueAsDateTime
      .set({
        year: dateFromFormatted.year,
        month: dateFromFormatted.month,
        day: dateFromFormatted.day,
      })
      .toISO();
  }

  public updateTimeFromFormatedTime(value: string, formatedTime: string) {
    const valueAsDateTime = DateTime.fromISO(value);
    const timeAsDateTime = DateTime.fromFormat(
      formatedTime,
      DATE_TIME_FORMATS.TIME
    );

    return valueAsDateTime
      .set({
        hour: timeAsDateTime.hour,
        minute: timeAsDateTime.minute,
      })
      .toISO();
  }

  public updateTimeFromDateTime(value: string, dateTime: DateTime) {
    const valueAsDateTime = DateTime.fromISO(value);
    return valueAsDateTime
      .set({
        hour: dateTime.hour,
        minute: dateTime.minute,
      })
      .toISO();
  }
}

export const DateTimeUtils = new DateTimeUtilsClass();
